import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectPageType } from '../../selectors/page';
import { EPageType } from '../../types/page';
import { VacancyContainer } from '../Vacancy';
import { ListingContainer } from '../Listing';
import { CareerContainer } from '../Career/CareerContainer';
import { NoSsr } from '@cian/react-utils';

export const PageContainer: React.FC = () => {
  const pageType = useSelector(selectPageType);

  switch (pageType) {
    case EPageType.Career:
      return <CareerContainer />;
    case EPageType.Card:
      return (
        <NoSsr>
          <VacancyContainer />
        </NoSsr>
      );
    case EPageType.Listing:
      return (
        <NoSsr>
          <ListingContainer />
        </NoSsr>
      );
    default:
      return null;
  }
};

PageContainer.displayName = 'PageContainer';
